import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type Component } from "vue";
import { useRoute } from "vue-router";

import Main from "@/layouts/Main";
import UnAuth from "@/layouts/unAuth";

interface PossibleComponents {
  [index: string]: Component;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const layouts: PossibleComponents = {
  Main,
  UnAuth
};

const activeGroup = computed(() => {
  const componentName = route.meta?.layout as string ?? "Main";
  return layouts[componentName];
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(activeGroup.value), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})